//#region Model Imports

import { Enums } from "../../models/common";
import { IOpObject } from "../../models/util/interfaces";

//#endregion

import { DetailsOptions } from "../../modules/common/details-popup/details-popup.directive";

//#region Consts

export const $COMPILE_SERVICE_NAME = '$compile'
export const $ELEMENT_SERVICE_NAME = '$element'
export const $Q_SERVICE_NAME = '$q'
export const $ROOT_SCOPE_SERVICE_NAME = '$rootScope'
export const $SCOPE_SERVICE_NAME = '$scope'
export const $STATE_SERVICE_NAME = '$state'
export const $STATE_SERVICE_PROVIDER_NAME = '$stateProvider'
export const $TIMEOUT_SERVICE_NAME = '$timeout'
export const $INTERVAL_SERVICE_NAME = '$interval'
export const $TRANSCLUDE_SERVICE_NAME = '$transclude'
export const $WINDOW_SERVICE_NAME = '$window'
export const BOWSER_SERVICE_NAME = 'bowser'

//#endregion

//#region Create Edit

export type CreateEditSuccessResult<TObject extends IOpObject> = {
    status: CreateEditResult.Status.Success;
    object: TObject;
}

export type CreateEditErrorResult = {
    status: CreateEditResult.Status.Error;
    error: any;
}

export type CreateEditCancelledResult = {
    status: CreateEditResult.Status.Cancelled;
}

export type CreateEditResult<TObject extends IOpObject> = CreateEditSuccessResult<TObject> | CreateEditErrorResult | CreateEditCancelledResult;

export namespace CreateEditResult {
    export enum Status {
        Success = 0,
        Cancelled = 1,
        Error = 2
    }
}

//#endregion

//#region Details   

export type DetailsResult = {
    status: DetailsResult.Status;
}

export namespace DetailsResult {
    export enum Status {
        Edited = 0,
        Deleted = 1,
        Closed = 2
    }
}


//#endregion

export type Language = {
    id: number
    locale: string
    image: string
    title: string
    short: string
}

//#region Details

export { DetailsOptions };

export interface OpenDetailsOrModuleOptions {
    moduleName?: Enums.SimaxModuleName,
    idReferenceType?: Enums.ReferenceType
    referenceObjectIds?: number[]
}

//#endregion
